import React from "react";
import { Route } from "react-router-dom";
import TermsAndConditions from "../Common/Terms&Condition";
import ContactUs from "../Common/ContactUs";
import Privacy from "../Common/Privacy";
import ResetPassword from "../Modules/Auth/ResetPassword";

const publicRoutes = [
  <Route key={'TermsRoute'} path="/terms" element={<TermsAndConditions />} />,
  <Route key={'ContactUsRoute'} path="/ContactUs" element={<ContactUs />} />,
  <Route key={'PrivacyRoute'} path="/privacy" element={<Privacy />} />,
  <Route key="AuthActionPublic" path="/auth/action" element={<ResetPassword />} />,
];

export default publicRoutes;
